import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.folharauto.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.folharauto.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionListaTrabalhador = ({dispatch},payload)=>{
    return serves.comissionado.listatrabalhador(payload).then(res => {
        dispatch('ActionSetListaTrabalhador',res)
    }).catch(err => {
        dispatch('ActionSetListaTrabalhador',res)
    })
}
export const ActionTomador = ({dispatch},payload)=>{
    return serves.folharauto.listatomador(payload).then(res => {
        dispatch('ActionSetListaTomador',res)
    }).catch(err => {
        dispatch('ActionSetListaTomador',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.comissionado.delete(payload).then(res => {
        
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',res)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.comissionado.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.comissionado.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetListaTrabalhador = ({commit},payload) =>{
    commit(types.SET_TRABALHADORES,payload)
}
export const ActionSetListaTomador = ({commit},payload) =>{
    commit(types.SET_TOMADORES,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
